import http from '@/backend/http'

const state = {
  settings: null,
  loading: false
}

const url = (accountId) => `/accounts/${accountId}/settings/`

const actions = {
  RETRIEVE: ({ commit, rootState }) => {
    const accountId = rootState.auth.account && rootState.auth.account.id
    if (!accountId) return Promise.resolve(null)

    commit('SET_LOADING', true)
    return http.get(url(accountId))
      .then(response => {
        commit('SET_SETTINGS', response.data)
        return response.data
      })
      .finally(() => commit('SET_LOADING', false))
  },

  UPDATE: ({ commit, rootState }, payload) => {
    const accountId = rootState.auth.account && rootState.auth.account.id
    if (!accountId) return Promise.reject(new Error('No active account'))

    return http.patch(url(accountId), payload)
      .then(response => {
        commit('SET_SETTINGS', response.data)
        return response.data
      })
  },

  RESET: ({ commit }) => {
    commit('SET_SETTINGS', null)
  }
}

const mutations = {
  SET_SETTINGS: (state, value) => {
    state.settings = value
  },
  SET_LOADING: (state, value) => {
    state.loading = value
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
